export default {
  "translation": {
    "Loading User": "Loading User...",
    "Loading": "Loading...",
    "Accept": "Accept [a]",
    "Reject": "Reject [x]",
  }
}
